import BrioLogoFooter from "../../../app/sidebar/BrioLogoFooter";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const MaintenancePage = () => {
    return (
        <Box
            sx={{
                backgroundColor: "background.paper",
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                px: 3,
            }}
        >
            <Box
                sx={{
                    width: "50%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    gap: 2,
                }}
            >
                <img
                    src="/images/logo-brio-blue.svg"
                    height="45px"
                    style={{width: "auto"}}
                    alt="Brio Platforma de Testare Fundamentată Științific"
                />
                <Typography variant="body1">
                    Lucrăm pentru a îmbunătăți experiența utilizatorilor noștri. Ne puteți contacta pe adresa de
                    e-mail <a href="mailto:office@brio.ro">office@brio.ro</a> pentru orice problemă sau întrebare. Vă
                    mulțumim pentru înțelegere!
                </Typography>
                <Typography variant="body1">- Echipa BRIO</Typography>

            </Box>
        </Box>
    )
}

export default MaintenancePage;